import { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import FwdRefNavLink from 'components/FwdRefNavLink'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      color: theme.palette.text.primary,
      padding: 0,
      '&:hover, &:focus': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
  }
})

interface IResultComponent {
  label?: ReactNode
  to: string
  icon?: any
  iconComp?: any
  children?: any
  [key: string]: any
}

const LinkListItem = ({ to, label, hoverText, icon, iconComp, children, secondaryText, ...rest }: IResultComponent) => {
  const classes = useStyles()
  const iconIfItExists = icon ? (
    <FontAwesomeIcon
      icon={icon}
      size="lg"
      fixedWidth
    />
  ) : null

  return (
    <ListItem
      className={classes.root}
      to={to}
      title={hoverText}
      aria-label={hoverText}
      component={FwdRefNavLink}
      disableGutters
      {...rest}
    >
      {children ? (
        children
      ) : (
        <Box
          display="flex"
          alignItems="center"
          width="100%"
        >
          <ListItemIcon>
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              ml={-1}
              mr={1}
              justifyContent="center"
            >
              {iconComp || iconIfItExists}
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={label}
            secondary={secondaryText}
          />
        </Box>
      )}
    </ListItem>
  )
}

export default LinkListItem
